import { render } from "./logoutSvgIcon.vue?vue&type=template&id=24f10aad"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__